import React__default, { useEffect } from 'react';
import { TreeSelect } from 'antd';
import getNormalizedData from './helpers/getNormalizedData.js';
import groupAccountsByCountry from './helpers/groupAccountsByCountry.js';
import setAccountHierarchy from './helpers/setAccountsHierarchy.js';
import DownOutlined from './../../../external/@ant-design/icons/es/icons/DownOutlined.js';

function DmCompanyPicker(props) {
  var accounts = props.accounts,
    value = props.value,
    placeholder = props.placeholder,
    onSelect = props.onSelect,
    onChange = props.onChange,
    disabled = props.disabled,
    showArrow = props.showArrow,
    style = props.style,
    className = props.className;
  var accountsGroupByCountry = groupAccountsByCountry(accounts);
  var accountsGroupByCountryWithHierarchy = setAccountHierarchy(accountsGroupByCountry);
  useEffect(function () {
    if (value) {
      var valueCheckMarkContainer = document.querySelector('.dm-company-picker-selector div.ant-select-selector span.ant-select-selection-item :first-child div[aria-label="check-marck"]');
      if (valueCheckMarkContainer) {
        valueCheckMarkContainer.style.display = 'none';
      }
      var valueFlagContainer = document.querySelector('.dm-company-picker-selector div.ant-select-selector span.ant-select-selection-item :first-child :first-child :first-child');
      if (valueFlagContainer && valueCheckMarkContainer) {
        valueFlagContainer.style.display = 'block';
      }
      var nameDescriptionContainer = document.querySelector('.dm-company-picker-selector div.ant-select-selector span.ant-select-selection-item div.dm-name-description-col');
      var nameDescriptionContainerFirstChild = document.querySelector('.dm-company-picker-selector div.ant-select-selector span.ant-select-selection-item div.dm-name-description-col :first-child');
      var nameDescriptionContainerLastChild = document.querySelector('.dm-company-picker-selector div.ant-select-selector span.ant-select-selection-item div.dm-name-description-col :last-child');
      if (nameDescriptionContainer && nameDescriptionContainerFirstChild && nameDescriptionContainerLastChild) {
        nameDescriptionContainer.style.width = '170px';
        nameDescriptionContainerFirstChild.style.width = '170px';
        nameDescriptionContainerLastChild.style.width = '170px';
      }
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: className
  }, /*#__PURE__*/React__default.createElement(TreeSelect, {
    id: "dm-company-picker-tree-select",
    treeDefaultExpandedKeys: [value],
    disabled: disabled,
    style: {
      width: 250
    },
    className: "dm-company-picker-selector dm-company-picker-tree-switcher dm-company-picker-select-tree-indent dm-company-picker-tree-treenode dm-company-picker-selector-input dm-company-picker-selector-placeholder dm-company-picker-select-arrow",
    dropdownStyle: {
      overflow: 'auto',
      padding: 0,
      paddingTop: '10px',
      borderRadius: '7px',
      boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.12)',
      zIndex: 1200,
      position: 'fixed'
    },
    dropdownClassName: "dm-company-picker-list-holder",
    value: value,
    onSelect: onSelect,
    onChange: onChange,
    treeData: getNormalizedData(accountsGroupByCountryWithHierarchy, value),
    showArrow: showArrow,
    switcherIcon: /*#__PURE__*/React__default.createElement(DownOutlined, {
      style: {
        color: '#4ab1eb',
        fontSize: '14px'
      }
    }),
    placeholder: placeholder,
    dropdownRender: function dropdownRender(menu) {
      return /*#__PURE__*/React__default.createElement("div", null, menu);
    }
  }));
}
DmCompanyPicker.defaultProps = {
  disabled: false,
  showArrow: true,
  value: undefined,
  accounts: undefined,
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  placeholder: ''
};

export { DmCompanyPicker };
